/* ============================================================
   TheNadShop · Header behavior
   ----------------------------------------
   Mobile (≤820px): hide on scroll-down after 80px threshold,
   reveal immediately on scroll-up. Desktop is always visible.
   Toggles class `tns-nav--hidden` on #header-group.
   ============================================================ */
(function(){
  const nav = document.getElementById('header-group');
  if(!nav) return;

  const MOBILE_BP = 820;
  const THRESHOLD = 80;
  const DELTA = 6;

  let lastY = window.scrollY;
  let ticking = false;

  const onScroll = () => {
    if(ticking) return;
    requestAnimationFrame(() => {
      const y = window.scrollY;
      const isMobile = window.innerWidth <= MOBILE_BP;
      if(!isMobile){
        nav.classList.remove('tns-nav--hidden');
        lastY = y;
        ticking = false;
        return;
      }
      if(Math.abs(y - lastY) < DELTA){
        ticking = false;
        return;
      }
      if(y > lastY && y > THRESHOLD){
        nav.classList.add('tns-nav--hidden');
      } else {
        nav.classList.remove('tns-nav--hidden');
      }
      lastY = y;
      ticking = false;
    });
    ticking = true;
  };

  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', () => {
    if(window.innerWidth > MOBILE_BP){
      nav.classList.remove('tns-nav--hidden');
    }
  });
})();
